// Maps a DrawerOption.moduleName to the platform.modules.key it corresponds
// to, for org-subscription gating (see use_nav_options.tsx). Any moduleName
// not listed here is treated as core/always-on — no platform.modules row
// exists for it today (reports/clientMapping/fileUpload/organizations are
// handled by their own explicit role-based rules in use_nav_options.tsx
// instead), so it's visible whenever role permission allows it, regardless
// of the caller's org subscriptions.
//
// Verified 1:1 against the live platform.modules catalog (14 rows) —
// surveyors and merchants each have their own catalog key and were
// previously mis-mapped onto choices/rewards respectively, which made them
// incorrectly inherit those other modules' subscription status. hospitals,
// landing-page, notifications and users had no entry at all, which made
// them always visible regardless of subscription.
export const moduleKeyMap: Record<string, string> = {
  schemes: "schemes",
  needs: "needs",
  jobs: "jobs",
  choices: "choices",
  surveyors: "surveyors",
  services: "services",
  rewards: "rewards",
  merchants: "merchants",
  cms: "cms",
  hospitals: "hospitals",
  "landing-page": "landing-page",
  notifications: "notifications",
  users: "users",
};
